import _ from 'lodash';
import { batchActions } from 'redux-batched-actions';

import * as Profile from 'app/entities/Profile';
import buildEntityActions from 'app/entity/utils/buildEntityActions';
import buildEntityApi from 'app/entity/utils/buildEntityApi';
import buildEntitySelectors from 'app/entity/utils/buildEntitySelectors';

export const type = 'subscription';

export const api = buildEntityApi(type, '/api/v3/subscriptions');

const BLOG_POSTS_ID = 'iterablezapierblog';
const PRODUCT_UPDATES_ID = 'iterablezapierproductupdates';
const NEWS_AND_SPECIAL_OFFERS_ID = 'iterablenewsspecialoffers';
const APP_UPDATES_AND_RECOMMENDATIONS_ID = 'iterableappupdatesrecommendations';

const IS_SUBSCRIBED = 'subscribed';

export const selectors = buildEntitySelectors(type, sel => {
  sel.description = _.partial(sel.dataItem, 'description');
  sel.name = _.partial(sel.dataItem, 'name');
  sel.isSubscribed = _.partial(sel.dataItem, IS_SUBSCRIBED);
  sel.all.isAllSubscribed = state => {
    const allEntity = sel.all.entity('all', state);
    return sel.isSubscribed(allEntity);
  };
  sel.all.isSubscribedToBlog = state => {
    return sel.isSubscribed(sel.all.entity(BLOG_POSTS_ID, state)) || false;
  };
});

export const actions = buildEntityActions(
  type,
  selectors,
  api,
  entityActions => {
    const originalSaveEntity = entityActions.saveEntity;

    // Whenever a single entity is saved we need to reload the collection
    // because saving one could impact others. For instance if `all` is
    // `subscribed: true` and then a user subscribes to a different entity,
    // the backend will change `all` to `subscribed: false` so we need to
    // refetch the whole collection to get the updated `all` entity.
    entityActions.saveEntity = (...args) => dispatch => {
      return dispatch(originalSaveEntity(...args)).then(() => {
        dispatch(entityActions.loadCollection());
      });
    };

    entityActions.updateIsSubscribed = _.partial(
      entityActions.updateEntityDataItem,
      IS_SUBSCRIBED
    );

    entityActions.subscribe = (messages, id) => dispatch => {
      dispatch(entityActions.updateIsSubscribed(true, id));
      dispatch(entityActions.saveEntity(messages, id));
    };

    entityActions.batchSubscribe = (messages, ids) => dispatch => {
      // Update all the given subscriptions to be marked as subscribed
      const subscribeActions = ids.map(id =>
        entityActions.updateIsSubscribed(true, id)
      );
      dispatch(batchActions(subscribeActions));

      // Now send the updates to the server
      return dispatch(entityActions.saveCollection(messages)).then(() =>
        // We have to reload the current profile because we expose a `is_gdpr_consented` attribute
        // on the profile model that depends on the subscription to these channels
        dispatch(Profile.actions.reloadCurrentProfile())
      );
    };

    entityActions.subscribeToBlog = _.partial(
      entityActions.subscribe,
      null,
      BLOG_POSTS_ID
    );

    entityActions.subscribeToMarketingChannels = () => dispatch =>
      dispatch(
        entityActions.batchSubscribe(null, [
          PRODUCT_UPDATES_ID,
          NEWS_AND_SPECIAL_OFFERS_ID,
          APP_UPDATES_AND_RECOMMENDATIONS_ID,
        ])
      );
  }
);
